import { FC } from "react"
import { Container, Typography } from "@mui/material"
import { useTitle, useUrlFilters } from "@/core/hooks"
import type { UrlFilterSchema } from "@/core/hooks"
import { LogsTable } from "../components/tables"
import { WorkflowStepper } from "../components/stepper/workflowStepper"

const FILTERS = {
  botId: "string",
  source: "string",
} as const satisfies UrlFilterSchema

export const GuestBotLogsPage: FC = () => {
  useTitle("Логи гостевых ботов")
  const { read, write } = useUrlFilters(FILTERS)
  const { botId, source } = read()
  return (
    <Container maxWidth={false}>
      <WorkflowStepper />
      <Typography variant="h5" mb={2}>
        Логи гостевых ботов
      </Typography>
      {/* useUrlFilters.write clears every omitted schema key: the clear-source
          handler must RE-PASS botId (F11) or the bot filter would be dropped.
          The {botId, source} schema and LogsTable's useUrlPagination write
          disjoint key sets — the v1 composed-updater problem cannot arise. */}
      <LogsTable
        botId={botId}
        source={source}
        onClearSource={() => write({ botId })}
      />
    </Container>
  )
}
